module.exports = __webpack_public_path__ + "img/TechGatherWood2_ua.91252695.webp";